<template>
  <v-layout>
    <v-flex>
      <v-alert
        :value="value"
        class="mb-3"
        type="info">{{ $t('timesheetCreatedButNotSaved') }}
      </v-alert>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'TimesheetCreatedNotSavedWarning',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  i18n: {
    messages: {
      de: {
        timesheetCreatedButNotSaved: 'Es wurde ein Vorschlag erstellt, jedoch noch nicht gespeichert. Bitte bestätigen Sie unten durch Speichern, dass diese Daten mit der Realität übereinstimmen. '
      },
      en: {
        timesheetCreatedButNotSaved: 'A proposal has been created but not yet saved. Please confirm below by saving that this data corresponds to reality. '
      },
      tr: {
        timesheetCreatedButNotSaved: 'Teklif oluşturuldu fakat henüz gönderilmedi. Lütfen kaydederek doğruluğunu onaylayınız. '
      },
      ru: {
        timesheetCreatedButNotSaved: 'Предложение было создано, но еще не сохранено. Пожалуйста, подтвердите ниже, сохранив, что эти данные соответствуют действительности.'
      }
    }
  }
}
</script>
